// src/pages/earningsImport/earningsSaver.js

import { db } from "../../firebase/firebase";
import {
  collection,
  addDoc,
  setDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";

async function ensureDriverWeeklyParent(driverId, company) {
  if (!driverId || driverId === "unknown") return;

  const parentRef = doc(db, "driverWeeklyEarnings", driverId);

  await setDoc(
    parentRef,
    {
      driverId,
      company: company || "",
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}

/* ============================================================
 * MERGE PLATFORM-SPECIFIC DRIVER MAPPINGS (UBER, BOLT, CAREEM…)
 * ============================================================ */
export async function saveAndMergeMappings(mappingUpdates, existingMappings, platform) {
  const platformKey = platform.toLowerCase();

  const merged = { ...existingMappings };

  Object.keys(mappingUpdates).forEach((platformDriverId) => {
    merged[platformDriverId] = mappingUpdates[platformDriverId];
  });

  await setDoc(
    doc(db, "driverPlatformMappings", platformKey),
    merged,
    { merge: true }
  );

  return merged;
}

/* ============================================================
 * SAVE MANUAL DRIVER MAPPINGS
 * ============================================================ */
export async function saveManualDriverMappings(mappingUpdates) {
  const ref = doc(db, "driverPlatformMappings", "manualMappings");

  const normalized = {};

  Object.keys(mappingUpdates).forEach((key) => {
    const norm = key.toLowerCase().trim();
    normalized[norm] = mappingUpdates[key];
  });

  await setDoc(ref, normalized, { merge: true });

  return normalized;
}

/* ============================================================
 * WEEKLY EARNINGS UPLOAD – FULLY UPGRADED
 * ============================================================ */
export async function saveEarningsToFirestore({
  rows,
  platform,
  month,
  week,
  mergedMappings,
  company,
  sourceFileName,
}) {
  const uploadBatchId = Date.now().toString(); // unique batch

  // ---- 1) Create top-level summary record ----
  await addDoc(
    collection(db, "weeklyEarningsUploads", month, week),
    {
      platform,
      month,
      week,
      company: company || "",
      sourceFileName: sourceFileName || "",
      uploadBatchId,
      totalRows: rows.length,
      createdAt: serverTimestamp(),
    }
  );

  // ---- 2) Store each driver row in subcollection ----
  for (const r of rows) {
    const platformDriverId = r.driver_id;
    const internalDriverId = mergedMappings[platformDriverId] || null;

    // CREATE PARENT DOC IF MISSING (FIX)
    await ensureDriverWeeklyParent(internalDriverId, company);

    await addDoc(
      collection(db, "driverWeeklyEarnings", internalDriverId || "unknown", "uploads"),
      {
        driverId: internalDriverId,
        driverName: r.name || "",
        platform,
        company: company || "",
        week,
        month,
        bankIncome: r.bank_income || 0,
        cashIncome: r.cash_income || 0,
        sourceDriverId: platformDriverId,
        sourceFileName: sourceFileName || "",
        uploadBatchId,
        createdAt: serverTimestamp(),
      }
    );
  }
}
